import type { Localized } from "../types/i18n";

export type NavLink = { href: string; label: Localized };

export const navLinks: NavLink[] = [
  { href: "#home", label: { en: "Home", es: "Inicio" } },
  { href: "#services", label: { en: "Services", es: "Servicios" } },
  { href: "#about", label: { en: "About Us", es: "Nosotros" } },
  { href: "#careers", label: { en: "Careers", es: "Empleos" } },
  { href: "#contact", label: { en: "Contact", es: "Contacto" } },
];
